import axios from "axios";
import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useLocation, useParams } from "react-router-dom";
import Breadcrumb from "../Component/BradeCrum";
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import ServiceImg from "../assets/Img/about-1.jpg"
import HeaderMobile from "../Component/MobileHader";
import { Hourglass } from "react-loader-spinner";

const ServiceCom = () => {
  const { titles } = useParams();
  const location = useLocation();
  const [content, setContent] = useState({});
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let currentPath = location.pathname;
    currentPath = currentPath.split("/")[1];

    setTitle(titles.split("-").join(" ")); // Convert titles to display format
    setLoading(true); // Show loader before making the API call

    axios
      .get(
        `${process.env.REACT_APP_GRIPHOLD_API_URL}/api/auth/getservices/${titles.split("-").join(" ")}`
      )
      .then((res) => {
        setContent(res.data); // Set content with API response
        setLoading(false); // Hide loader once data is fetched
      })
      .catch((err) => {
        console.error(err); // Handle API error
        setLoading(false); // Hide loader even if there's an error
      });

    window.scrollTo(0, 0); // Scroll to top when the component loads
  }, [location, titles]);
  return (
    <React.Fragment>
            {loading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100vh",
                      }}
                    >
                      <Hourglass
                        height={80}
                        width={80}
                        color="#01458e"
                        ariaLabel="loading-content"
                      />
                    </div>
                  ) : (
      <div>
      <HeaderMobile />
      <Breadcrumb heading={title} bTitle={title} />
      <Container className="galleryRow ">
        <div className="sub-title text-animation">
          <h6>
            {/* {title} */}
            {title}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={50}
              height={6}
              viewBox="0 0 50 6"
            >
              <path d="M50 3L45 0.113249V5.88675L50 3ZM0 3.5H45.5V2.5H0V3.5Z" />
            </svg>
          </h6>
        </div>
        <div className="serviceSubTitle">
          {content.shortDescription}
        </div>
        <Card className="serviceCardNew">
          <Row>
            <Col lg={5}>
            <img src={`${process.env.REACT_APP_GRIPHOLD_API_URL}/${content.ServiceImage}`} alt="img" />
            </Col>
            <Col lg={7}>
            <div dangerouslySetInnerHTML={{__html:content.Description}}></div>
            </Col>
          </Row>
        </Card>
       {content.ServiceImage2 && content.ServiceImage2 !==null && <Card className="serviceCardNew">
          <Row>
          <Col lg={7}>
            <div dangerouslySetInnerHTML={{__html:content.Description2}}></div>
            </Col>
            <Col lg={5}>
            <img src={`${process.env.REACT_APP_GRIPHOLD_API_URL}/${content.ServiceImage2}`} alt="img" />
            </Col>
          </Row>
        </Card>}
        {content.ServiceImage3 && content.ServiceImage3 !==null && <Card className="serviceCardNew">
          <Row>
            <Col lg={5}>
            <img src={`${process.env.REACT_APP_GRIPHOLD_API_URL}/${content.ServiceImage3}`} alt="img" />
            </Col>
            <Col lg={7}>
            <div dangerouslySetInnerHTML={{__html:content.Description3}}></div>
            </Col>
          </Row>
        </Card>}
       
      </Container>
      </div>
        )}
    </React.Fragment>
  );
};

export default ServiceCom;
